import { ComponentSettings } from "../settings/settings";

export const settings = {
  permission: {},
  text: {
    drag: {
      de: "Datei hierher ziehen und ablegen oder",
      en: "Drag and drop file here or",
      nl: "Sleep het bestand hierheen of",
    },

    browse: {
      de: "Nach Datei suchen",
      en: "Browse for file",
      nl: "Bladeren naar bestand",
    },
  },
  list: {},
  url: {},
  field: {},
  additionalInfo: {},
};

export const dragDrop: ComponentSettings<typeof settings> = settings;
